import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss'],
})
export class NoticeComponent {
  @Input() icon?: string;
  @Input() title: string;
  @Input() body: string;
  @Input() type: 'info' | 'danger' | 'success' | 'urgent' = 'info';
  @Input() size: 'sm' | 'md' = 'md';
  @Input() fill?: 'outline' | 'transparent' = 'outline';
}
